module.exports = __webpack_public_path__ + "img/gdgkl-meetup-april-1.6e4b1222.png";